module.exports = __webpack_public_path__ + "static/logo-8d573bc7146b0fec473c60b207c3cbf9.png";